<template>
	<div class="flex-wrapper bb-header-wrapper">
		<Button type="link" class="pd-sm-x pd-left-0" @click="onBack">
			<template #icon><ArrowLeftOutlined :style="{ color: colorBlack }"/></template>
		</Button>
		<TypographyTitle :level="2" class="bb-header flex-grow">{{ header }}</TypographyTitle>
		<Space>
			<slot></slot>
		</Space>
	</div>
</template>

<script>
import { TypographyTitle, Button, Space } from 'ant-design-vue';
import { ArrowLeftOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';

import Consts from '@/api/Consts';

export default {
	components: {
		TypographyTitle, Button, Space, ArrowLeftOutlined,
	},
	props: {
		header: {
			type: String,
			required: true,
		},
		backTo: {
			type: String,
			default: null,
		},
	},
	setup(props) {
		const router = useRouter();

		const onBack = () => {
			if (props.backTo) {
				router.push({ name: props.backTo });
				return;
			}
			router.go(-1);
		};

		return {
			colorBlack: Consts.COLORS.dark0,
			onBack,
		};
	},
}
</script>

<style scoped>
.bb-header {
	margin-bottom: 0.2em;
}

.bb-header-wrapper {
	align-items: center;
	margin-bottom: 12px;
}
</style>
